<template>
  <div class="mr-lg-5">
    <v-menu
      v-model="menu"
      :key="menuKey"
      bottom
      rounded
      transition="slide-y-transition"
      nudge-bottom="4"
      max-width="300"
      offset-y
      :close-on-content-click="false"
      class="menu-branch"
      :close-on-outside-click="false"
      persistent
    >
      <template #activator="{ on }">
        <v-btn
          depressed
          v-on="on"
          outlined
          color="first"
          height="30px"
          class="ms-lg-5 px-2 py-1"
        >
          <span
            class="p-fs-xs p-fw-normal me-1"
            v-if="
              confirmedBranchYearId &&
              confirmedFinancialYearId &&
              confirmedFinancialYearId.text
            "
          >
            {{ confirmedBranchYearId.text }}
            دوره مالی {{ confirmedFinancialYearId.text }}
          </span>
          <v-icon size="18" class="ms-1">
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-card class="bg-p-list">
        <v-card-title class="pt-2 pb-0 d-flex justify-space-between">
          <h6 class="p-fs-n p-fw-normal text-p-dark">
            {{ label.caption.branchAndFiscalYearSelection }}
          </h6>
          <v-tooltip left :open-on-focus="false">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                size="20"
                color="first"
                @click="add"
                v-bind="attrs"
                v-on="on"
              >
                mdi-plus
              </v-icon>
            </template>
            <span> ثبت جدید </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="branchYearId"
                :items="myBrancheOptions"
                return-object
                outlined
                dense
                hide-details
                class="text-center"
                color="first"
                item-color="first"
                @change="onBranchChange"
              >
                <template #label>
                  <label class="p-label">{{ label.form.branch }}</label>
                </template>
                <template v-slot:append>
                  <v-icon color="#64748b " size="14pt">
                    mdi-chevron-down
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-1">
              <v-autocomplete
                :v-key="myFiscalYearOptions.length"
                v-model="financialYearId"
                :items="myFiscalYearOptions"
                return-object
                outlined
                no-data-text="سال مالی برای این شعبه ثبت نشده است"
                dense
                hide-details
                class="text-center"
                color="first"
                item-color="first"
                @change="updateLocalStorage"
              >
                <template #label>
                  <label class="p-label">{{ label.form.financialYear }}</label>
                </template>
                <template v-slot:append>
                  <v-icon color="#64748b " size="14pt">
                    mdi-chevron-down
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0 px-4">
          <v-spacer></v-spacer>
          <v-btn small depressed class="px-3 py-1 btn-p-first" @click="submit">
            {{ label.button.confirm }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";

export default {
  name: "FiscalYearMenu",
  data() {
    return {
      label,
      menu: false,
      menuKey: 0,
      branchYearId: null,
      financialYearId: null,
      isConfirmed: false,

      confirmedBranchYearId: null,
      confirmedFinancialYearId: null,
    };
  },
  computed: {
    ...mapGetters({
      myBrancheOptions: "dropdownX/myBrancheOptions",
      myFiscalYearOptions: "dropdownX/myFiscalYearOptions",
      postCheckFiscalYear: "postCheckFiscalYear",
      fiscalYear: "dropdownX/fiscalYearById",
      loadingBtn: "loadingBtn",
    }),
  },
  watch: {
    postCheckFiscalYear() {
      if (this.postCheckFiscalYear) {
        this.close();
        setTimeout(() => {
          localStorage.removeItem("voucherFromDate");
          localStorage.removeItem("voucherToDate");
          if (
            this.$route.name == "PACNTAddVoucher" ||
            this.$route.name == "PACNTEditVoucher"
          ) {
            this.$router.push({ name: "PACNTVoucherList" }).catch(() => {});
          } else {
            location.reload();
          }
        }, 200);
      }
    },

    // myBrancheOptions() {
    //   if (localStorage.getItem("BranchId")) {
    //     let find = this.myBrancheOptions.find(
    //       (z) => z.value == localStorage.getItem("BranchId"),
    //     );
    //     if (find) {
    //       this.branchYearId = find;
    //       this.confirmedBranchYearId = find;
    //       this.getFinancialYear();
    //     }
    //   }
    // },
    myBrancheOptions(val) {
      if (!val.length) return;

      let find = val.find((z) => z.value == localStorage.getItem("BranchId"));

      if (!find) {
        find = val[val.length - 1];
      }

      this.branchYearId = find;
      this.confirmedBranchYearId = find;
      this.getFinancialYear();
    },
    myFiscalYearOptions() {
      const isNewBranch =
        this.confirmedBranchYearId !== null &&
        this.confirmedBranchYearId !== this.branchYearId;

      this.setDefaultFiscalYear(isNewBranch);
    },
    menu(val) {
      if (val && this.branchYearId?.value) {
        this.$store.dispatch(
          "dropdownX/getMyFiscalYear",
          this.branchYearId.value,
        );
      }
    },
    // myFiscalYearOptions() {
    //   if (localStorage.getItem("FiscalYearId")) {
    //     let find = this.myFiscalYearOptions.find(
    //       (z) => z.value == localStorage.getItem("FiscalYearId")
    //     );
    //     if (find) {
    //       this.financialYearId = find;
    //       localStorage.setItem("defaultFiscalYear", find.text);
    //     } else {
    //       this.financialYearId = this.myFiscalYearOptions[0].value;
    //       localStorage.setItem("defaultFiscalYear", this.myFiscalYearOptions[0].text);
    //       this.updateLocalStorage();
    //     }
    //   }
    // },

    // myFiscalYearOptions() {
    //   if (localStorage.getItem("FiscalYearId")) {
    //     let find = this.myFiscalYearOptions.find(
    //       (z) => z.value == localStorage.getItem("FiscalYearId"),
    //     );
    //     if (find) {
    //       this.financialYearId = find;
    //       localStorage.setItem("defaultFiscalYear", find.text);
    //     } else if (this.myFiscalYearOptions.length > 0) {
    //       this.financialYearId = this.myFiscalYearOptions[0];
    //       localStorage.setItem(
    //         "defaultFiscalYear",
    //         this.myFiscalYearOptions[0].text,
    //       );
    //     }
    //   } else if (this.myFiscalYearOptions.length > 0) {
    //     this.financialYearId = this.myFiscalYearOptions[0];
    //     localStorage.setItem(
    //       "defaultFiscalYear",
    //       this.myFiscalYearOptions[0].text,
    //     );
    //   }
    // },
    branchYearId: {
      handler(newVal) {
        if (newVal && newVal.value) {
          localStorage.setItem("BranchId", newVal.value);
        }
      },
      deep: true,
    },
    financialYearId: {
      handler(newVal) {
        if (newVal && newVal.value) {
          localStorage.setItem("FiscalYearId", newVal.value);
          this.$store.dispatch("dropdownX/getFiscalYearsById", newVal.value);
        }
      },
      deep: true,
    },
    fiscalYear() {
      if (this.fiscalYear) {
        localStorage.setItem(
          "startYear",
          JSON.stringify(this.fiscalYear.startDate),
        );
        localStorage.setItem(
          "endYear",
          JSON.stringify(this.fiscalYear.endDate),
        );
        localStorage.setItem("fiscalYearInfo", JSON.stringify(this.fiscalYear));
      }
    },
  },
  methods: {
    setDefaultFiscalYear(preferLast = false) {
      if (this.myFiscalYearOptions.length === 0) return;

      let selected;

      if (localStorage.getItem("FiscalYearId") && !preferLast) {
        const find = this.myFiscalYearOptions.find(
          (z) => z.value == localStorage.getItem("FiscalYearId"),
        );
        if (find) selected = find;
      }

      if (!selected) {
        selected = preferLast
          ? this.myFiscalYearOptions[this.myFiscalYearOptions.length - 1]
          : this.myFiscalYearOptions[0];
      }

      this.financialYearId = selected;
      this.confirmedFinancialYearId = selected;
      localStorage.setItem("defaultFiscalYear", selected.text);
    },

    getFinancialYear() {
      this.financialYearId = null;
      this.$store.dispatch(
        "dropdownX/getMyFiscalYear",
        this.branchYearId?.value,
      );
    },
    onBranchChange() {
      this.financialYearId = null;
      if (this.branchYearId?.value) {
        localStorage.setItem("BranchId", this.branchYearId.value);
      }
      this.$store.dispatch(
        "dropdownX/getMyFiscalYear",
        this.branchYearId?.value,
      );
    },

    updateLocalStorage() {
      if (this.financialYearId?.value) {
        localStorage.setItem("FiscalYearId", this.financialYearId.value);
      } else if (this.financialYearId) {
        localStorage.setItem("FiscalYearId", this.financialYearId);
      }
      this.confirmedBranchYearId = this.branchYearId;
      this.confirmedFinancialYearId = this.financialYearId;
      this.submit();
    },
    submit() {
      if (
        (this.financialYearId?.value && this.branchYearId?.value) ||
        (this.financialYearId && this.branchYearId)
      ) {
        this.confirmedBranchYearId = this.branchYearId;
        this.confirmedFinancialYearId = this.financialYearId;

        this.financialYearId.value
          ? this.$store.dispatch(
              "pbaseX/changeFiscalYear",
              this.financialYearId.value,
            )
          : this.$store.dispatch(
              "pbaseX/changeFiscalYear",
              this.financialYearId,
            );
        this.resetMenu();
      }
    },

    resetMenu() {
      this.menu = false;
      this.menuKey += 1;
    },
    add() {
      this.resetMenu();
      this.$router.push({ name: "PBASEFiscalYear" }).catch(() => {});
    },
    close() {
      this.resetMenu();
    },
  },
  mounted() {
    this.$store.dispatch("dropdownX/getMyBranches");
    this.menu = false;
    // if (localStorage.getItem("isConfirmed") === "true") {
    //   this.isConfirmed = true;
    // }
  },
};
</script>
